const globals = {
    //_URL_REST: 'https://d3r7fwcjx820vo.cloudfront.net/radioRest/index.php/api',
    _URL_REST: 'https://webinars.spinmedia.es:3018',
    _URL_SOURCES: 'https://d3r7fwcjx820vo.cloudfront.net',
};

export default globals;
